<div>
  <app-mat-spinner-overlay *ngIf="showSpinner"></app-mat-spinner-overlay>

  <!-- Show tabs only if a partner loan exists -->
  <div *ngIf="loanSummary?.PLoan_Id > 0">
    <div class="row m-0 mt-3">
      <!-- Tab order depends on the portal -->
      <ng-container *ngIf="isPartnerPortal; else lmsTabs">
        <div class="col-md-6 p-0">
          <button class="btn btn-outline-green btn-lg btn-block loan-statement-tab" [ngClass]="{ active: tab == 'plist' }"
            (click)="changeTabList('plist')">
            <span class="loan-tab-title">Partner Loan Statement</span>
            <span *ngIf="watermarkStatus !== undefined" class="loan-status-badge"
              [ngClass]="watermarkStatus === 'Closed' ? 'loan-status-closed' : 'loan-status-active'">
              <span class="loan-status-dot"></span>
              {{ watermarkStatus === 'Closed' ? 'Closed' : 'Active' }}
            </span>
          </button>
        </div>
        <div class="col-md-6 pr-0">
          <button class="btn btn-outline-green btn-lg btn-block loan-statement-tab" [ngClass]="{ active: tab == 'clist' }"
            (click)="changeTabList('clist')">
            <span class="loan-tab-title">Customer Loan Statement</span>
            <span *ngIf="customerwatermarkStatus !== undefined" class="loan-status-badge"
              [ngClass]="customerwatermarkStatus === 'Closed' ? 'loan-status-closed' : 'loan-status-active'">
              <span class="loan-status-dot"></span>
              {{ customerwatermarkStatus === 'Closed' ? 'Closed' : 'Active' }}
            </span>
            <span *ngIf="customerDPDDays !== undefined && customerDPDDays !== null" class="loan-dpd-badge">
              DPD : {{ customerDPDDays }}
            </span>
          </button>
        </div>
      </ng-container>

      <ng-template #lmsTabs>
        <div class="col-md-6 p-0">
          <button class="btn btn-outline-green btn-lg btn-block loan-statement-tab" [ngClass]="{ active: tab == 'clist' }"
            (click)="changeTabList('clist')">
            <span class="loan-tab-title">Customer Loan Statement</span>
            <span *ngIf="customerwatermarkStatus !== undefined" class="loan-status-badge"
              [ngClass]="customerwatermarkStatus === 'Closed' ? 'loan-status-closed' : 'loan-status-active'">
              <span class="loan-status-dot"></span>
              {{ customerwatermarkStatus === 'Closed' ? 'Closed' : 'Active' }}
            </span>
            <span *ngIf="customerDPDDays !== undefined && customerDPDDays !== null" class="loan-dpd-badge">
              DPD : {{ customerDPDDays }}
            </span>
          </button>
        </div>
        <div class="col-md-6 pr-0">
          <button class="btn btn-outline-green btn-lg btn-block loan-statement-tab" [ngClass]="{ active: tab == 'plist' }"
            (click)="changeTabList('plist')">
            <span class="loan-tab-title">Partner Loan Statement</span>
            <span *ngIf="watermarkStatus !== undefined" class="loan-status-badge"
              [ngClass]="watermarkStatus === 'Closed' ? 'loan-status-closed' : 'loan-status-active'">
              <span class="loan-status-dot"></span>
              {{ watermarkStatus === 'Closed' ? 'Closed' : 'Active' }}
            </span>
          </button>
        </div>
      </ng-template>
    </div>

    <!-- Partner tab: only render child when PLoanSummary is ready -->
    <div class="row m-0 mt-2" *ngIf="tab == 'plist' && PLoanSummary">
      <app-lms-loanStatement [loanSummary]="PLoanSummary" [PageType]="PageType" [PLoanType]="PLoanType"
        [FirstEMIDate]="FirstEMIDate">
      </app-lms-loanStatement>
    </div>
    <!-- Show loading spinner while fetching partner data -->
    <div class="row m-0 mt-2" *ngIf="tab == 'plist' && !PLoanSummary && showSpinner">
      <div class="col-12 text-center">Loading partner loan data...</div>
    </div>

    <!-- Customer tab: render immediately -->
    <div *ngIf="tab == 'clist'">
      <app-lms-loanStatement [loanSummary]="loanSummary" [PageType]="PageType">
      </app-lms-loanStatement>
    </div>
  </div>

  <!-- If no partner loan exists, just show customer statement -->
  <div *ngIf="loanSummary?.PLoan_Id <= 0">
    <app-lms-loanStatement [loanSummary]="loanSummary" [PageType]="PageType"></app-lms-loanStatement>
  </div>
</div>
